<template>
  <v-row class="mx-9">
    <v-autocomplete
      filled
      :items="items"
      :label="label"
      color="secondary"
      :id="`filter-${label}`"
      clearable
      v-model="info"
      @input="$emit('update:info', info)"
    ></v-autocomplete>
  </v-row>
</template>
<script>
export default {
  props: {
    info: String,
    items: Array,
    label: String,
  },
};
</script>
